export const payMethodsMap = {
  wechat: '微信',
  alipay: '支付宝',
  huabei: '花呗分期',
  jd: '白条分期',
};
export const HUABEI_TYPE = 'huabei';
export const HUABEI_TYPE_ID = 30;
export const BAITIAO_TYPE = 'jd';
export const BAITIAO_TYPE_ID = 50;

export const promotionTypeMap = {
  coupon: '优惠券',
  union: '联报优惠',
  priceOff: '直降优惠',
  discount: '满减优惠',
  group: '拼团减免',
  single: '促销优惠',
};
export const COUPON_TYPE = 'coupon';

export const payTypeMap = {
  10: 'wechat',
  20: 'alipay',
  30: 'huabei',
  50: 'jd',
};

export const payIcons = {
  10: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/1610181565656709062.png',
  20: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/1610181601633634823.png',
  30: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/1610181627277528462.png',
  50: 'https://iqh-zt-pord-cdn.iqihang.com/23jxH5/jd-pay.png',

};

export const successTextConfig = {
  '1-1': {
    stepText: '加入答疑群,和小伙伴们一起学习一起进步',
    cardTitle: '加入答疑群',
    cardTips: '和小伙伴们一起学习一起进步',
    buttonText: '一键加群',
    miniButtonText: '长按二维码保存图片，前往QQ扫码添加',
  },
  '1-2': {
    stepText: '加助教QQ，享更多福利',
    cardTitle: '加助教QQ，享更多福利',
    cardTips: '和小伙伴们一起学习一起进步',
    buttonText: '点击添加',
    miniButtonText: '长按二维码保存图片，前往QQ扫码添加',
  },
  '2-1': {
    stepText: '加入答疑群',
    cardTitle: '加入答疑群',
    cardTips: '和小伙伴们一起学习一起进步',
    buttonText: '保存二维码，去微信加群',
    miniButtonText: '长按二维码，添加微信群',
  },
  '2-2': {
    stepText: '加助教微信，享更多福利',
    cardTitle: '加助教微信，享更多福利',
    cardSubTitle: '微信号：',
    buttonText: '复制微信号并添加',
    miniButtonText: '长按二维码，添加助教',
  },
  // '2-3': {
  //   stepText: '扫码关注“启航教育”官方公众号',
  //   cardTitle: '扫码关注“启航教育”官方公众号',
  //   cardSubTitle: '参与更多优惠活动',
  //   buttonText: '保存二维码，去微信关注公众号',
  // },
  '2-3': {
    stepText: '扫码关注“启航教育”官方公众号',
    cardTitle: '关注“启航教育”官方公众号',
    cardSubTitle: '参与更多优惠活动',
    buttonText: '前往关注',
    miniButtonText: '长按二维码，添加服务号',
  },
  '2-1-3': {
    stepText: '加入答疑群',
    cardTitle: '加入答疑群',
    cardTips: '和小伙伴们一起学习一起进步',
    buttonText: '前往微信添加',
    miniButtonText: '长按二维码，添加微信群',
  },
  '2-2-3': {
    stepText: '加助教微信，享更多福利',
    cardTitle: '加助教微信，享更多福利',
    cardSubTitle: ' ',
    buttonText: '前往微信添加',
    miniButtonText: '长按二维码，添加助教',
  },
};

export const labelMap = {
  single: {
    1: '折后价',
    2: '秒杀',
    3: '秒杀',
  },
  union: '联报',
  fullReduction: '满减',
};
